import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TechnicianPerformanceTable = ({ data, loading = false }) => {
  const [sortConfig, setSortConfig] = useState({ key: 'completionRate', direction: 'desc' });

  const handleSort = (key) => {
    setSortConfig({
      key,
      direction: sortConfig?.key === key && sortConfig?.direction === 'desc' ? 'asc' : 'desc'
    });
  };

  const sortedData = [...data]?.sort((a, b) => {
    if (sortConfig?.direction === 'asc') {
      return a?.[sortConfig?.key] > b?.[sortConfig?.key] ? 1 : -1;
    }
    return a?.[sortConfig?.key] < b?.[sortConfig?.key] ? 1 : -1;
  });

  const SortIcon = ({ columnKey }) => {
    if (sortConfig?.key !== columnKey) {
      return <Icon name="ChevronsUpDown" size={14} className="text-muted-foreground" />;
    }
    return sortConfig?.direction === 'asc' ? 
      <Icon name="ChevronUp" size={14} className="text-primary" /> : 
      <Icon name="ChevronDown" size={14} className="text-primary" />;
  };

  if (loading) {
    return (
      <div className="bg-card rounded-lg border border-border card-elevated-1 overflow-hidden">
        <div className="p-6">
          <div className="h-6 bg-muted rounded w-1/3 mb-4"></div>
          <div className="space-y-3">
            {[1, 2, 3, 4, 5]?.map((i) => (
              <div key={i} className="h-12 bg-muted rounded animate-pulse"></div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg border border-border card-elevated-1 overflow-hidden">
      <div className="p-6 border-b border-border">
        <h3 className="text-lg font-semibold text-foreground">Performance des techniciens</h3>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted/50">
            <tr>
              <th className="text-left p-4 text-sm font-medium text-muted-foreground">
                Technicien
              </th>
              <th 
                className="text-left p-4 text-sm font-medium text-muted-foreground cursor-pointer hover:text-foreground transition-colors"
                onClick={() => handleSort('interventions')}
              >
                <div className="flex items-center gap-2">
                  Interventions
                  <SortIcon columnKey="interventions" />
                </div>
              </th>
              <th 
                className="text-left p-4 text-sm font-medium text-muted-foreground cursor-pointer hover:text-foreground transition-colors"
                onClick={() => handleSort('completionRate')}
              >
                <div className="flex items-center gap-2">
                  Taux de résolution
                  <SortIcon columnKey="completionRate" />
                </div>
              </th>
              <th 
                className="text-left p-4 text-sm font-medium text-muted-foreground cursor-pointer hover:text-foreground transition-colors"
                onClick={() => handleSort('avgTime')}
              >
                <div className="flex items-center gap-2">
                  Temps moyen
                  <SortIcon columnKey="avgTime" />
                </div>
              </th>
              <th 
                className="text-left p-4 text-sm font-medium text-muted-foreground cursor-pointer hover:text-foreground transition-colors"
                onClick={() => handleSort('satisfaction')}
              >
                <div className="flex items-center gap-2">
                  Satisfaction
                  <SortIcon columnKey="satisfaction" />
                </div>
              </th>
              <th className="text-left p-4 text-sm font-medium text-muted-foreground">
                Statut
              </th>
            </tr>
          </thead>
          <tbody>
            {sortedData?.map((tech) => (
              <tr key={tech?.id} className="border-t border-border hover:bg-muted/30 transition-colors">
                <td className="p-4">
                  <div className="flex items-center gap-3">
                    <Image 
                      src={tech?.avatar} 
                      alt={tech?.avatarAlt}
                      className="w-10 h-10 rounded-full object-cover"
                    />
                    <div>
                      <p className="font-medium text-foreground">{tech?.name}</p>
                      <p className="text-xs text-muted-foreground">{tech?.specialty}</p>
                    </div>
                  </div>
                </td>
                <td className="p-4">
                  <span className="font-medium text-foreground">{tech?.interventions}</span>
                </td>
                <td className="p-4">
                  <div className="flex items-center gap-2">
                    <div className="flex-1 bg-muted rounded-full h-2 max-w-[100px]">
                      <div 
                        className="bg-success h-2 rounded-full transition-all duration-300"
                        style={{ width: `${tech?.completionRate}%` }}
                      />
                    </div>
                    <span className="text-sm font-medium text-foreground">{tech?.completionRate}%</span>
                  </div>
                </td>
                <td className="p-4">
                  <span className="text-sm text-foreground">{tech?.avgTime}</span>
                </td>
                <td className="p-4">
                  <div className="flex items-center gap-1">
                    <Icon name="Star" size={14} className="text-warning fill-warning" />
                    <span className="text-sm font-medium text-foreground">{tech?.satisfaction}</span>
                  </div>
                </td>
                <td className="p-4">
                  <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium ${
                    tech?.status === 'active' ? 'bg-success/10 text-success' :
                    tech?.status === 'busy'? 'bg-warning/10 text-warning' : 'bg-muted text-muted-foreground'
                  }`}>
                    <span className="w-1.5 h-1.5 rounded-full bg-current"></span>
                    {tech?.status === 'active' ? 'Actif' : 
                     tech?.status === 'busy'? 'Occupé' : 'Hors ligne'}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TechnicianPerformanceTable;